import MapView from "../../../components/views/pages/MapView/MapView"
import Movements from "../../../components/views/pages/Movements/Movements"
import PartialTrip from "../../../components/views/pages/PartialTrip/PartialTrip"
import AgendaView from "../../../components/views/pages/ResourceView/AgendaView"
import ShipmentMovements from "../../../components/views/pages/ShipmentMovements/ShipmentMovements"
import TripRoutes from "../../../components/views/pages/TripRoutes/TripRoutes"
import VehicleResource from "../../../components/views/pages/VehicleResource/VehicleResource"

function commonPageService() {

    const mapPages = (name, isChildTile, isPinFlag, guid, isCustomView) => {
        switch (name) {
            case "Movements": return <Movements routeName={'/movements'} isChild={isChildTile} isPin={isPinFlag} customView={isCustomView} guid={guid}/>
            case "Partial Trip": return <PartialTrip routeName={'/partialtrip'} isChild={isChildTile} isPin={isPinFlag} customView={isCustomView} guid={guid}/>
            case "Agenda View": return <AgendaView routeName={'/agenda-view'} isChild={isChildTile} customView={isCustomView} guid={guid}/>
            case "Routes": return <TripRoutes routeName={'/route'} isChild={isChildTile} isPin={isPinFlag} customView={isCustomView} guid={guid}/>
            case "Shipment Movements": return <ShipmentMovements routeName={'/shipment-movements'} isChild={isChildTile} isPin={isPinFlag} customView={isCustomView} guid={guid}/>
            case "Map": return <MapView isChild={isChildTile} customView={isCustomView} guid={guid}/>
            case "Vehicle Resource": return <VehicleResource routeName={'/vehicle-resource'} isChild={isChildTile} isPin={isPinFlag} customView={isCustomView} guid={guid}/>
            default:
            break;
        }
    }

    return {
        mapPages
    };
}

export default commonPageService;